import { render, staticRenderFns } from "./PetwizardView.vue?vue&type=template&id=6379797f"
import script from "./PetwizardView.vue?vue&type=script&lang=js"
export * from "./PetwizardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports